<template>
  <div class="card ">
    <a-form :label-col="{ span: 2 }" :wrapper-col="{ span: 18 }" :form="formData" ref="form">
      <a-form-item label="平台:">
        <a-radio-group name="radioGroup" v-model="formData.pvd">
          <a-radio value="tikTok">
            抖音
          </a-radio>
          <a-radio value="kuaishou">
            快手
          </a-radio>
        </a-radio-group>
      </a-form-item>
      <a-form-item label="商品链接">
        <div class="block-widget">
          <div style="flex-grow: 1">
            <a-input v-model="formData.content" type="textarea" :rows="8" placeholder="每行一个商品链接，多个商品链接换行"
            ></a-input>
            <TipTool content="请确认商家链接设置好库存，如没设库存，有超跑风险。"></TipTool>
          </div>
        </div>
      </a-form-item>
      <div class="btns">
        <a-button type="primary" @click="onImport">
          导入商品
        </a-button>
        <a-button style="margin-left: 10px;" @click="onReset">
          重置
        </a-button>
      </div>
    </a-form>
  </div>
</template>

<script>
import TipTool from "@/components/TipTool";
import {goodAdd} from "@/api/merchant-registration";

export default {
  name: "goods-import",
  components: {TipTool},
  data() {
    return {
      formData: {
        pvd: 'tikTok',
        content: ''
      },
      formItemLayout: {
        labelCol: {
          xs: {span: 2},
          sm: {span: 22},
        },
        wrapperCol: {
          xs: {span: 2},
          sm: {span: 22},
        },
      },
    }
  },

  mounted() {
  },

  methods: {
    onImport() {
      if (this.formData.content.length == 0) {
        return this.$message.error('请输入商品链接')
      }
      goodAdd(this.formData).then(() => {
        this.formData.content = ''
        this.$message.success('添加成功')
      })
    },
    onReset() {
      this.formData.content = ''
    }
  }
}
</script>

<style scoped lang="scss">
.card {
  background: #FFFFFF;
  box-shadow: 0px 0px 28px 0px rgba(217, 217, 217, 0.19);
  border-radius: 13px;
  padding: 24px;
  min-height: 90vh;
}

.btns {
  display: flex;
  justify-content: center;
  margin-top: 100px;

  ::v-deep .ant-btn-primary {
    background: #8D12F8;
    border-color: #8D12F8;
  }

}
</style>
